import { PropsWithChildren } from "react";
import { NavLink } from "react-router";

import { Box, Drawer, Stack } from "@mui/material";

import logo from "../../../assets/logo.svg?no-inline";
import logoSmall from "../../../assets/logo_small.svg?no-inline";

interface Props extends PropsWithChildren {
  homeTo: string;
  ariaLabel: string;
  logoAlt: string;
  isNavigationCollapsed: boolean;
  navigationWidth: number;
}

// The app-shell sidebar chrome shared by both apps: the permanent drawer with the FSW styling and
// the logo linking home, sized by the shared collapse state. The apps supply their own item lists
// as children (laid out top vs. bottom by the space-between stack).
export function NavigationDrawer({
  homeTo,
  ariaLabel,
  logoAlt,
  isNavigationCollapsed,
  navigationWidth,
  children,
}: Props) {
  return (
    <Drawer
      variant="permanent"
      role="navigation"
      aria-label={ariaLabel}
      sx={{
        "& .MuiDrawer-paper": {
          bgcolor: "fsw.blue-5",
          px: 2,
          pt: 2.5,
          pb: 4,
          position: "static",
        },
        height: "100%",
        width: `${navigationWidth}px`,
      }}
    >
      <Box sx={{ px: isNavigationCollapsed ? 0 : 1, pt: 0.5, height: 51, mb: 5 }}>
        <NavLink to={homeTo}>
          <Box
            component="img"
            src={isNavigationCollapsed ? logoSmall : logo}
            alt={logoAlt}
            height={41}
            width={isNavigationCollapsed ? 32 : "100%"}
          />
        </NavLink>
      </Box>

      <Stack flex={"1 1 100%"} justifyContent={"space-between"} gap={2}>
        {children}
      </Stack>
    </Drawer>
  );
}
